import "./Card.css";
import bulb from "../../../../../../assets/bulb.png";
const Card = ({ type, setAffiliateModal }) => {
 return (
  <div className="products-card">
   <div className="contents">
    <div className="img-container">
     <img src={bulb} alt="bulb" />
    </div>
    <div className="text-container">
     <div className="heading">
      <p className="code">7200064678</p>
      <p
       className={
        type.toLowerCase() === "vocational skill"
         ? "badge vocational"
         : "badge " + type.toLowerCase()
       }
      >
       {type}
      </p>
     </div>
     <p className="title">Mind Games of a Broken Heart</p>
     <p className="commision">Affiliate comm: 50</p>
     <div className="shapBtn-container">
      <p onClick={() => setAffiliateModal(true)} className="shapBtn1">
       View Affiliate Link
      </p>
      <a href="/" className="shapBtn2">
       View performance
      </a>
     </div>
    </div>
   </div>
   <p className="amount">N45,000</p>
  </div>
 );
};

export default Card;
